export default {
  Error: {
    ExpiredSession: {
      Name: "ErrorResponse",
      Error: "login_required"
    }
  }
}